import loan from "./images/loan.png";
const FeaturedProject = () => {
  return (
    <section
      data-aos="fade-up"
      data-aos-duration="1500"
      data-aos-once="false"
      data-aos-mirror="true"
      className="container mx-auto px-6 py-20"
    >
      <h2 className="text-4xl md:text-5xl font-bold text-center text-lime-500 mb-12">
        Featured Project
      </h2>

      <div className="bg-gradient-to-r from-gray-700 to-lime-900 rounded-xl p-8 md:flex gap-8">
        <div className="md:w-1/2">
          <h3 className="text-3xl font-bold text-lime-400 mb-4">
            Loan Management & Tracking System
          </h3>

          <p className="text-gray-200 mb-4">
            A full-featured microloan platform where users can apply for loans
            and track their application status in real time.
          </p>

          <ul className="list-disc ml-5 text-gray-300 space-y-2">
            <li>Role-based dashboards (User, Admin, Manager)</li>
            <li>Loan approval & rejection workflow</li>
            <li>Application fee & status tracking</li>
            <li>
              Secure payment systems using Stripe for application fees and
              transactions.
            </li>
            <li>Secure backend & database design</li>
          </ul>

          <p className="mt-4 text-sm text-gray-300">
            <strong>Tech:</strong> React, Node.js, Express, MongoDB, JWT,
            Tailwind
          </p>
        </div>

        <div className="md:w-1/2 flex items-center justify-center mt-6 md:mt-0">
          <img src={loan} alt="Loan App" className="rounded-xl shadow-lg" />
        </div>
      </div>
    </section>
  );
};

export default FeaturedProject;
